import { sanitizeUrl } from '@braintree/sanitize-url';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ExpandableTitleText from 'common/components/Elements/ExpandableTitleText/ExpandableTitleText';
import { clientUrlPath } from 'common/utilities/browser/url/url';
import type * as I from 'core/api/coreApiClient';
import ContactInfo from 'core/components/App/ContactInfo/ContactInfo';
import PaperPage from 'core/components/Elements/PaperPage/PaperPage';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import I18n from 'i18n/en-US';
import React from 'react';
import { useSelector } from 'react-redux';

interface ComponentProps {
  title: string;
  content?: string;
  e2eId: string;
  errorTitle?: string;
  errorStack?: string;
  incident?: I.Incident;
  returnToDefaultFirstPage?: boolean;
}

function ErrorPage({
  title, content, e2eId, errorTitle, errorStack, returnToDefaultFirstPage, incident,
}: ComponentProps) {
  const configuration = useSelector((state: ApplicationState) => state.configuration.configuration);

  return (
    <Box flexGrow={1} data-e2e-page={e2eId}>
      <PaperPage>
        <Typography variant="h1" align="center">{title}</Typography>
        <Box mb={2} />
        <Typography align="center">{content}</Typography>
        {incident && (
          <Typography>
            {I18n.Screens.ErrorPage.incident(incident.incidentId)}
          </Typography>
        )}
        <Box mt={1} textAlign="center">
          <ContactInfo variant="body1" />
        </Box>
        {errorTitle && (
          <div style={{ whiteSpace: 'pre-line' }}>
            <Box mb={2} />
            <Typography>{I18n.Screens.ErrorPage.info}</Typography>
            {!errorStack && <Typography variant="body2">{errorTitle}</Typography>}
            {errorStack && <ExpandableTitleText title={errorTitle} text={errorStack} />}
          </div>
        )}
        {returnToDefaultFirstPage && configuration.default_first_page_url && (
          <Box mt={1}>
            <Link href={sanitizeUrl(clientUrlPath(configuration.default_first_page_url))}>
              {I18n.Screens.ErrorPage.return}
            </Link>
          </Box>
        )}
      </PaperPage>
    </Box>
  );
}

export default ErrorPage;
